export enum User_status {
  Enabled = 'enabled',
  Disabled = 'disabled'
}

export const User_status_Dictionary = {
  [User_status.Enabled]: 'Ενεργός',
  [User_status.Disabled]: 'Ανενεργός'
};

export const User_status_Dictionary_Caps = {
  [User_status.Enabled]: 'ΕΝΕΡΓΟΣ',
  [User_status.Disabled]: 'ΑΝΕΝΕΡΓΟΣ'
};

export const User_Status_DictOut = {
  [User_status.Enabled]: 'Ενεργός',
  [User_status.Disabled]: 'Αποκλεισμένος'
};